<template>
  <div class="l-os">
    <h2>Izaberite operativni sistem.</h2>
    <div class="l-os-grid">
      <div
        class="l-os-grid__item"
        v-for="system in systems"
        :key="system.name"
        @click="selectSystem(system)"
      >
        <div
          class="c-card c-card--system"
          :class="selectedSystem.platformName === system.platformName && 'c-card--selected'"
        >
          <div class="c-card__img">
            <AppIcon
              :name="system.iconName"
              classes="c-icon--md"
            />
          </div>

          <div class="c-card__title">
            {{ system.platformName }}
          </div>

          <div class="c-card__info u-font-weight-bold">
            {{ system.name }}
          </div>
        </div>
      </div>
      
    </div>
  </div>
</template>

<script>
import AppIcon from './AppIcon';

export default {
  name: 'ChooseSystem',
  components: {
    AppIcon,
  },

  props: {
    selectedSystem: {
      name: {
        type: String,
        required: true,
      },
    },
    systems: {
       name: {
        type: Array,
        required: true,
      },
    }
  },

  methods: {
    selectSystem(system) {
      this.$emit('onSelectSystem', system);
    },
  }
};
</script>

<style></style>
